export class GoodsGroupDto {

  public static readonly DEFAULT_SOURCE = "CUSTOM";

  public id!: string;
  public name!: string;
  public source: string = GoodsGroupDto.DEFAULT_SOURCE;
  public externalId: string | undefined;

  constructor(init?: Partial<GoodsGroupDto> | undefined) {
    Object.assign(this, init);
  }

  public isEditable(): boolean {
    return this.source === GoodsGroupDto.DEFAULT_SOURCE;
  }
}
